import {Link} from "react-router-dom";
import MainContainer from "../../../components/MainContainer";
import useDocumentTitle from "../../../hooks/useDocumentTitle";

const ChooseActionPage = () => {
  useDocumentTitle("Επιλογή ενέργειας");

  return (
    <MainContainer>
      <div className="content p-3 my-3">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <Link
                to="/tickets/confirmation"
                className="btn btn-back mb-4"
              >
                <svg
                  className="govgr-svg-icon--caret govgr-svg-icon"
                  focusable="false"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path d="M18,22V2L6,12L18,22z"></path>
                </svg>
                Πίσω
              </Link>
              <h2 className="mb-4">Eπιλέξτε</h2>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <Link
                    to="/tickets/choose-minor"
                    className="action-card-link btn btn-primary w-100 d-flex justify-content-center"
                  >
                    <span className="my-auto">
                      <h2>Αδειοδότηση συνοδείας ανηλίκου</h2>
                      <p className="white">
                        Άδεια σε τρίτο άτομο για συνοδεία.
                      </p>
                    </span>
                  </Link>
                </div>
                <div className="col-md-6">
                  <Link
                    to="/tickets/cancel-events"
                    className="action-card-link btn btn-primary w-100 d-flex justify-content-center"
                  >
                    <span className="my-auto">
                      <h2>Άδειες συνοδείας ανηλίκων</h2>
                      {/* <p className="white">Ενεργές αδειοδοτήσεις: 2</p> */}
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MainContainer>
  );
};
export default ChooseActionPage;
